export const yesOrNoOptions = [
    {
        label: 'Yes',
        value: `Yes`,
    },
    {
        label: 'No',
        value: `No`,
    },
];
